import React from 'react';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {vscDarkPlus} from 'react-syntax-highlighter/dist/esm/styles/prism';
import MermaidRenderer from './MermaidRenderer';

interface CodeRendererProps {
    language: string;
    value: string;
}

const CodeRenderer: React.FC<CodeRendererProps> = ({language, value}) => {
    const safeLanguage = language || 'text';

    if (safeLanguage.toLowerCase() === 'mermaid') {
        return <MermaidRenderer chart={value} />;
    }

    return (
        <SyntaxHighlighter
            language={safeLanguage}
            style={vscDarkPlus}
            wrapLongLines={true}
        >
            {value}
        </SyntaxHighlighter>
    );
};

export default CodeRenderer;
